import { CSSProperties, FC } from 'react';
import classNames from 'classnames';
import i18n from '@shared/i18n/index';

import styles from './index.module.less';
import BaseErrorImg from './Invalid-image.png';
import { BaseImage } from '../BaseImage';

interface BaseErrorProps {
	errImg?: string;
	errorText?: string;
	className?: string;
	style?: CSSProperties;
	imageClassName?: string;
	errorTextClassName?: string;
}

export const BaseError: FC<BaseErrorProps> = (props) => {
	const {
		errorText = i18n.get('Business_PleaseReCreate_Toast'),
		errImg = BaseErrorImg,
		className = '',
		imageClassName = '',
		style = {},
		errorTextClassName = '',
	} = props;
	return (
		<div
			className={classNames(
				{
					[styles.errorWrapper]: true,
				},
				className,
			)}
			style={style}
		>
			<BaseImage alt="a1 image" src={errImg} width={36} height={36} imgClass={imageClassName} />
			<p
				className={classNames(
					{
						[styles.errorText]: true,
					},
					errorTextClassName,
				)}
			>
				{errorText}
			</p>
		</div>
	);
};
